import React, { useEffect, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import SuccessOrErrorModal from './SuccessOrErrorModal'

const ContactFormNew = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    countryCode: '+1',
    phoneNumber: '',
    projectType: '',
    currency: 'usd',
    budget: '',
    timeline: '',
    message: '',
  })

  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [submitError, setSubmitError] = useState(false)
  const [recaptchaToken, setRecaptchaToken] = useState(null)

  const recaptchaRef = useRef(null)

  useEffect(() => {
    if (show) {
      setFormData({
        name: '',
        email: '',
        company: '',
        countryCode: '+1',
        phoneNumber: '',
        projectType: '',
        currency: 'usd',
        budget: '',
        timeline: '',
        message: '',
      })
      setErrors({})
      setIsSubmitting(false)
      setSubmitSuccess(false)
      setSubmitError(false)
      setRecaptchaToken(null)
      if (recaptchaRef.current) {
        recaptchaRef.current.reset()
      }
      updateBudgetOptions('usd')
    }
  }, [show])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))

    // Clear error on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }))
    }
  }

  const updateBudgetOptions = (currency) => {
    const budgetSelect = document.getElementById('budget')
    if (!budgetSelect) return

    if (currency === 'usd') {
      budgetSelect.innerHTML = `
        <option value="">Select budget</option>
        <option value="Under $25K">Under $25K</option>
        <option value="$25K - $50K">$25K - $50K</option>
        <option value="$50K - $100K">$50K - $100K</option>
        <option value="$100K - $250K">$100K - $250K</option>
        <option value="More than $250K">$250K+</option>
        <option value="Not Sure Yet">Not Sure Yet</option>
      `
    } else {
      budgetSelect.innerHTML = `
        <option value="">Select budget</option>
        <option value="Under ₹10L">Under ₹10L</option>
        <option value="₹10L - ₹20L">₹10L - ₹20L</option>
        <option value="₹20L - ₹50L">₹20L - ₹50L</option>
        <option value="₹50L - ₹1Cr">₹50L - ₹1Cr</option>
        <option value="More than ₹1Cr">₹1Cr+</option>
        <option value="Not Sure Yet">Not Sure Yet</option>
      `
    }
  }

  const handleCurrencyChange = (e) => {
    const currency = e.target.value
    setFormData((prev) => ({ ...prev, currency, budget: '' }))
    updateBudgetOptions(currency)
  }

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token)
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) newErrors.name = 'Name is required'
    if (!formData.email.trim()) newErrors.email = 'Email is required'
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = 'Email is invalid'
    if (!formData.company.trim()) newErrors.company = 'Company name is required'
    //if (!formData.phoneNumber.trim()) newErrors.phoneNumber = 'Phone number is required';
    //if (!formData.projectType) newErrors.projectType = 'Project type is required';
    //if (!formData.budget) newErrors.budget = 'Budget range is required';
    if (!formData.message.trim())
      newErrors.message = 'Project details are required'
    if (!recaptchaToken) newErrors.recaptcha = 'Please complete the reCAPTCHA'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Get form data
    // const formData = new FormData(e.target);

    if (!validateForm()) return

    setIsSubmitting(true)
    setSubmitError(false)

    try {
      if (formData.currency === 'usd') {
        formData.budgetFormatted = formData.budget.replace(/\$/g, '&#36;') // Dollar
      } else if (formData.currency === 'inr') {
        formData.budgetFormatted = formData.budget.replace(/₹/g, '&#8377;')
      }

      const htmlContent = `<div style="background: #fff; max-width: 520px; margin: 30px auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,.07); padding: 0 24px 24px 24px;">
  <div style="text-align: center; padding: 32px 0 16px 0;">
    <img src="https://stately-beignet-d61876.netlify.app/assets/images/idesign.jpg" alt="Company Logo" style="height: 40px; width: auto; margin-bottom: 2px;">
  </div>
  
  <h2 style="font-size: 22px; margin-top: 0; margin-bottom: 16px; font-weight: bold;
    background: linear-gradient(90deg, #1598F0 0%, #1ABF64 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;">New Project Inquiry</h2>
  <table style="font-size: 15px; border-collapse: collapse; width: 100%; margin-bottom: 14px;">
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Name:</th>
      <td style="padding: 7px 0;">${formData.name}</td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Email:</th>
      <td style="padding: 7px 0;"><a href="mailto:${formData.email}" style="color: #1598F0; text-decoration: none;">${formData.email}</a></td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Company:</th>
      <td style="padding: 7px 0;">${formData.company}</td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Phone:</th>
      <td style="padding: 7px 0;"><a href="tel:+19944953584" style="color: #1ABF64; text-decoration: none;">${formData.countryCode} ${formData.phoneNumber}</a></td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Project Type:</th>
      <td style="padding: 7px 0;">${formData.projectType}</td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Budget:</th>
      <td style="padding: 7px 0;">${formData.budgetFormatted}</td>
    </tr>
    <tr>
      <th style="color: #7c7c7c; font-weight: 500; width: 130px; text-align: left; padding: 7px 0;">Timeline:</th>
      <td style="padding: 7px 0;">${formData.timeline}</td>
    </tr>
  </table>
  <div style="background: #f3faf6; border-left: 4px solid #1ABF64; padding: 14px 18px; font-size: 15px; margin-top: 12px; border-radius: 3px;">
    <strong>Message:</strong> ${formData.message}
  </div>
  
  <!-- Footer with Powered by Message -->
  <div style="margin-top: 32px; border-top: 1px solid #eee; padding-top: 14px; text-align: center; color: #9c9c9c; font-size: 13px; letter-spacing: 0.3px;">
    Powered by <a href="https://www.i-design.in/" style="color: #1598F0; text-decoration: none;">iDesign Technologies Pvt Ltd</a>
  </div>
</div>`

      const dataToSend = {
        name: formData.name,
        email: formData.email,
        company: formData.company,
        phone: `${formData.countryCode} ${formData.phoneNumber}`,
        projectType: formData.projectType,
        budget: formData.budget,
        timeline: formData.timeline,
        message: formData.message,
        htmlContent: htmlContent,
      }

      fetch('https://api.saasymarket.com/admin/message', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      })
        .then((response) => {
          if (response.ok) {
            setSubmitSuccess(true)
            // Scroll to top of modal body instead of window
            const modalBody = document.querySelector('.modalcontent')
            if (modalBody) {
              modalBody.scrollTo({ top: 0, behavior: 'smooth' })
            }
            //setTimeout(() => {
            // setSubmitSuccess(false)
            //  setIsSubmitting(false)
            // setShowError(false)
            //}, 3000)

            setFormData({
              name: '',
              email: '',
              company: '',
              countryCode: '+1',
              phoneNumber: '',
              projectType: '',
              currency: 'usd',
              budget: '',
              timeline: '',
              message: '',
            })
            // Reset reCAPTCHA
            if (recaptchaRef.current) {
              recaptchaRef.current.reset()
            }
            setRecaptchaToken(null)
          } else {
            setSubmitError(true)
            // Scroll to top of modal body instead of window
            const modalBody = document.querySelector('.modalcontent')
            if (modalBody) {
              modalBody.scrollTo({ top: 0, behavior: 'smooth' })
            }
            //setTimeout(() => {
            // setSuccess(false);
            //setIsSubmitting(false)
            //setSubmitError(false)
            //  }, 3000)
          }
        })
        .catch((error) => {
          setSubmitError(true)
          // Scroll to top of modal body instead of window
          const modalBody = document.querySelector('.modalcontent')
          if (modalBody) {
            modalBody.scrollTo({ top: 0, behavior: 'smooth' })
          }
          //  setTimeout(() => {
          //setSuccess(false);
          // setIsSubmitting(false)
          //  }, 3000)
          console.error('Error sending message:', error)
        })
    } catch (error) {
      console.error('Error submitting form:', error)
      setSubmitError(true)
      setIsSubmitting(false)
    }
  }

  const handleClose = () => {
    // if (window.confirm('Are you sure you want to close the form? Any unsaved changes will be lost.')) {
    onClose()
    //  }
  }

  if (!show) return null

  return (
    <div
      className='modal-overlay'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
      }}
    >
      <div
        className='modal-content'
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '32px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',

          // overflowY: 'auto',
          boxShadow:
            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        }}
      >
        <div
          className='modal-header'
          style={{
            marginBottom: '12px',
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative', // For absolute close fallback if needed
            width: '100%',
          }}
        >
          <h2
            className='modal-title'
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              background: 'linear-gradient(90deg, #1598F0 0%, #1ABF64 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              margin: 0,
            }}
          >
            Start Your Project
          </h2>
          <button
            type='button'
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              color: '#6b7280',
              marginLeft: 'auto', // pushes the button to far right in flex
            }}
            aria-label='Close modal'
          >
            <svg
              width='20'
              height='20'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M6 18L18 6M6 6l12 12'
              ></path>
            </svg>
          </button>
        </div>
        <p
          className='modal-description'
          style={{
            color: '#6b7280',
            fontSize: '14px',
            // marginTop: '8px',
            marginBottom: '24px',
          }}
        >
          Tell us about your software development needs and we'll provide a
          tailored solution for your business.
        </p>
        <div
          className='modalcontent'
          style={{
            flex: 1,
            overflowY: 'auto',
            paddingRight: '8px',
            overflowX: 'hidden',
          }}
        >
          {/* Removed inline success/error alerts in favor of modal window */}

          {/* New modal window for success/error messages */}
          {/* {(submitSuccess || submitError) && (
            <div
              className='modal-overlay'
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 100000,
              }}
            >
              <div
                className='modal-message-window'
                style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '24px 32px',
                  maxWidth: '400px',
                  width: '90%',
                  boxShadow:
                    '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                  textAlign: 'center',
                  position: 'relative',
                }}
              >
                <h3
                  style={{
                    marginBottom: '16px',
                    color: submitSuccess ? '#059669' : '#dc2626', // Tailwind green-600 or red-600
                    fontWeight: 'bold',
                    fontSize: '20px',
                  }}
                >
                  {submitSuccess
                    ? 'Request submitted successfully!'
                    : 'Message sending failed'}
                </h3>
                <p
                  style={{
                    fontSize: '16px',
                    color: '#374151',
                    marginBottom: '24px',
                  }}
                >
                  {submitSuccess
                    ? 'Our team will review your project requirements and get back to you within 24 hours.'
                    : 'Please try again later.'}
                </p>
                <button
                  onClick={() => {
                    if (submitSuccess) {
                      setSubmitSuccess(false)
                      setIsSubmitting(false)
                    }
                    if (submitError) {
                      setSubmitError(false)
                      setIsSubmitting(false)
                    }
                  }}
                  style={{
                    padding: '10px 24px',
                    backgroundColor: submitSuccess ? '#059669' : '#dc2626',
                    border: 'none',
                    borderRadius: '8px',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '16px',
                  }}
                  aria-label='Close message modal'
                >
                  Close
                </button>
              </div>
            </div>
          )} */}

          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='name'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
                  ></path>
                </svg>
                Name <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type='text'
                id='name'
                name='name'
                className={`form-input  ${errors.name ? 'is-invalid' : ''}`}
                placeholder='Your full name'
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              {errors.name && (
                <div className='invalid-feedback'>{errors.name}</div>
              )}
            </div>

            {/* Email Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='email'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
                  ></path>
                </svg>
                Work Email <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type='email'
                id='email'
                name='email'
                className={`form-input  ${errors.email ? 'is-invalid' : ''}`}
                placeholder='your.email@company.com'
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {errors.email && (
                <div className='invalid-feedback'>{errors.email}</div>
              )}
            </div>

            {/* Company Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='company'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4'
                  ></path>
                </svg>
                Company Name <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type='text'
                id='company'
                name='company'
                className={`form-input ${errors.company ? 'is-invalid' : ''}`}
                placeholder='Your company name'
                value={formData.company}
                onChange={handleInputChange}
                required
              />
              {errors.company && (
                <div className='invalid-feedback'>{errors.company}</div>
              )}
            </div>

            {/* Phone Field */}
            <div className='form-group mb-3'>
              <label
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
                  ></path>
                </svg>
                Phone
              </label>
              <div className='d-flex gap-2'>
                <select
                  id='countryCode'
                  name='countryCode'
                  className='form-select'
                  style={{ width: '140px' }}
                  value={formData.countryCode}
                  onChange={handleInputChange}
                >
                  <option value='+1'>+1 (US)</option>
                  <option value='+91'>+91 (IN)</option>
                  <option value='+44'>+44 (UK)</option>
                  <option value='+61'>+61 (AU)</option>
                  <option value='+86'>+86 (CN)</option>
                  <option value='+49'>+49 (DE)</option>
                  <option value='+33'>+33 (FR)</option>
                  <option value='+81'>+81 (JP)</option>
                  <option value='+82'>+82 (KR)</option>
                  <option value='+65'>+65 (SG)</option>
                </select>
                <input
                  type='tel'
                  id='phoneNumber'
                  name='phoneNumber'
                  className={` form-input  ${
                    errors.phoneNumber ? 'is-invalid' : ''
                  }`}
                  placeholder='555 000 0000'
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
              {errors.phoneNumber && (
                <div className='invalid-feedback d-block'>
                  {errors.phoneNumber}
                </div>
              )}
            </div>

            {/* Project Type Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='projectType'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
                  ></path>
                </svg>
                Project Type <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                id='projectType'
                name='projectType'
                className={`form-select ${
                  errors.projectType ? 'is-invalid' : ''
                }`}
                value={formData.projectType}
                onChange={handleInputChange}
                required
              >
                <option value=''>Select type</option>
                <option value='Web Application'>Web Application</option>
                <option value='Mobile App'>Mobile App</option>
                <option value='Enterprise Software'>Enterprise Software</option>
                <option value='AI/ML Solutions'>AI/ML Solutions</option>
                <option value='E-commerce'>E-commerce</option>
                <option value='SaaS Platform'>SaaS Platform</option>
                <option value='Custom Development'>Custom Development</option>
                <option value='Other'>Other</option>
              </select>
              {errors.projectType && (
                <div className='invalid-feedback'>{errors.projectType}</div>
              )}
            </div>

            {/* Currency and Budget Fields */}
            <div className='row mb-3'>
              <div className='col-6'>
                <label
                  htmlFor='currency'
                  className='form-label d-flex align-items-center gap-2'
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    marginBottom: '8px',
                    color: '#374151',
                  }}
                >
                  <svg
                    className='icon'
                    style={{ width: '16px', height: '16px' }}
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                    ></path>
                  </svg>
                  Currency
                </label>
                <select
                  id='currency'
                  name='currency'
                  className='form-select'
                  value={formData.currency}
                  onChange={handleCurrencyChange}
                >
                  <option value='usd'>USD</option>
                  <option value='inr'>INR</option>
                </select>
              </div>

              <div className='col-6'>
                <label
                  htmlFor='budget'
                  className='form-label'
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    marginBottom: '8px',
                    color: '#374151',
                  }}
                >
                  Budget Range
                </label>
                <select
                  id='budget'
                  name='budget'
                  className={`form-select ${errors.budget ? 'is-invalid' : ''}`}
                  value={formData.budget}
                  onChange={handleInputChange}
                >
                  <option value=''>Select budget</option>
                  <option value='Under $25K'>Under $25K</option>
                  <option value='$25K - $50K'>$25K - $50K</option>
                  <option value='$50K - $100K'>$50K - $100K</option>
                  <option value='$100K - $250K'>$100K - $250K</option>
                  <option value='More than $250K'>$250K+</option>
                  <option value='Not Sure Yet'>Not Sure Yet</option>
                </select>
                {errors.budget && (
                  <div className='invalid-feedback'>{errors.budget}</div>
                )}
              </div>
            </div>

            {/* Timeline Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='timeline'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
                  ></path>
                </svg>
                Project Timeline
              </label>
              <select
                id='timeline'
                name='timeline'
                className='form-select'
                value={formData.timeline}
                onChange={handleInputChange}
              >
                <option value=''>Select timeline</option>
                <option value='Urgent (1-2 weeks)'>Urgent (1-2 weeks)</option>
                <option value='1 Month'>1 Month</option>
                <option value='2-3 Months'>2-3 Months</option>
                <option value='3-6 Months'>3-6 Months</option>
                <option value='More than 6 Months'>6+ Months</option>
                <option value='flexible'>Flexible</option>
              </select>
            </div>

            {/* Message Field */}
            <div className='form-group mb-3'>
              <label
                htmlFor='message'
                className='form-label d-flex align-items-center gap-2'
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '8px',
                  color: '#374151',
                }}
              >
                <svg
                  className='icon'
                  style={{ width: '16px', height: '16px' }}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z'
                  ></path>
                </svg>
                Project Details <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <textarea
                id='message'
                name='message'
                className={`form-textarea  ${
                  errors.message ? 'is-invalid' : ''
                }`}
                placeholder="Describe your project requirements, timeline, and any specific technologies you'd like us to use..."
                rows='4'
                value={formData.message}
                onChange={handleInputChange}
                required
              />
              {errors.message && (
                <div className='invalid-feedback'>{errors.message}</div>
              )}
            </div>

            {/* reCAPTCHA Field */}
            <div
              className='form-group mb-3'
              style={
                {
                  //display: 'flex',
                  //justifyContent: 'center',
                  //width: '100%',
                }
              }
            >
              <div className='recaptcha-scale'>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey='6Ld96AcsAAAAAHcFzFioAG4y59LnMdGOBC0ZizxK'
                  onChange={handleRecaptchaChange}
                />
              </div>
              {errors.recaptcha && (
                <div className='invalid-feedback d-block'>
                  {errors.recaptcha}
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className='d-flex gap-3 mt-4'>
              <button
                type='button'
                className=' contact-button flex-fill contact-button-outline'
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type='submit'
                id='submitBtn'
                className='contact-button contact-button-primary'
                style={{
                  background:
                    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <SuccessOrErrorModal
        submitSuccess={submitSuccess}
        submitError={submitError}
        setSubmitSuccess={setSubmitSuccess}
        setSubmitError={setSubmitError}
        setIsSubmitting={setIsSubmitting}
      />
    </div>
  )
}

export default ContactFormNew
